import React from "react";
import DonutChart from "../../../components/donut/donut";

export const GuestsAndActivitiesPies = ({
  chartData: { activitiesValues = [], guestsValues = [] } = {},
  chartData = {}
}) => {
  let formattedPiesData = [];

  if (Object.keys(chartData).length > 0) {
    formattedPiesData = [
      { title: "Closed Guests", values: guestsValues },
      { title: "Activities", values: activitiesValues }
    ];
  }

  return (
    <div className="dailyPulse__section dailyPulse__section__row guests-and-activities-pies">
      {formattedPiesData.length &&
        formattedPiesData.map((pie) => {
          return (
            <div className="content" key={pie.title}>
              <p className="title">{pie.title}</p>
              {pie.values.map((pie, index) => {
                const { name, rawDataLink, share, value, average } = pie;
                return (
                  <div className="content__el" key={name}>
                    <DonutChart
                      url={rawDataLink}
                      type={name}
                      value={share * 100}
                      average={average}
                      averageText={index == 0 ? "Daily Averages" : ""}
                      dollarValue={value}
                      hidePercentChanged
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
    </div>
  );
};
